import {
  Spinner,
  boxShadows,
  colors,
  fontSizes,
  sizes,
  mixin,
  Icon,
  iconSizes,
  themeColors,
} from "@hubrise/react-components"
import { NavLink } from "react-router-dom"
import styled from "styled-components"

export const StyledCatalog = styled.div`
  margin-bottom: 1.5rem;
  background-color: white;
  border-radius: ${sizes.borderRadius};
  box-shadow: ${boxShadows.small};
`

export const Header = styled.div`
  padding: 0 1.5rem 0 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #fbfbfb;
  border-bottom: 1px solid #f2f1f1;
  border-radius: ${sizes.borderRadius} ${sizes.borderRadius} 0 0;
`

export const Title = styled.div`
  overflow: hidden;
  display: flex;
  font-size: ${fontSizes._14};
  cursor: pointer;
  padding: 1.25rem 1rem 1.25rem 2rem;
  position: relative;
`

export const Unsaved = styled.div`
  position: absolute;
  left: 1rem;
  top: 1.25rem;
`

export const UnsavedSymbol = styled.div`
  width: 1rem;
  height: 1rem;
  ${mixin.centerElement};
`

export const Name = styled.div`
  ${mixin.noWrapEllipsis};
  font-weight: 500;
`

export const Id = styled.div`
  white-space: nowrap;
  color: ${colors.textLight};
  font-weight: 400;

  :before {
    content: "-";
    padding: 0 0.25em;
  }
`

export const DuplicationInProgress = styled.div`
  display: flex;
  color: ${colors.textLight};
  align-items: center;
  gap: 0.5rem;
`

export const Controls = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: row;
  align-items: baseline;
  justify-content: end;
  gap: 1em;
`

export const ButtonAppLink = styled(NavLink)`
  font-weight: 500;
  border: none;
  border-radius: ${sizes.borderRadius};
  padding: 0.5rem 1rem;
  color: white;
  background-color: ${themeColors.primary};
  transition: background-color 0.1s ease;

  &:hover {
    background-color: #777;
  }
`

export const Content = styled.div`
  padding: 1.25em 1.5em;
`

export const StyledSpinner = styled(Spinner)`
  position: relative;
  top: 1px;
`

export const Link = styled.div`
  color: ${themeColors.primary};
  display: flex;
  align-items: center;
  padding: 0 1rem;
`

export const Label = styled.div`
  font-weight: 500;
`

export const LinkIcon = styled(Icon).attrs({ code: "arrow_drop_down", size: iconSizes._25 })`
  margin-left: 0.25em;
`
